import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import {
  UzemszunetForras, UzemszunetService, aktivVagyJovobeli, idoablakSzoveg, kozelgo,
} from './uzemszunet.service';

/*  ÜZEMSZÜNET-SÁV – diszkrét figyelmeztető sáv egy oldal tetején.
 *
 *  Bemenet: `forras` (pl. 'nav', 'aggreg8', 'ugyfelkapu', 'eonkormanyzat'). A közös
 *  UzemszunetService-ből olvassa az állapotot (cache-elt, így sok banner egy lekérésen
 *  osztozik). Ha az adott forrás állapota 'ok' – vagy az időablak már lejárt –, SEMMIT nem
 *  renderel. A funkciót nem tiltja, csak jelez. */

@Component({
  selector: 'app-uzemszunet-sav',
  standalone: true,
  imports: [CommonModule, IonicModule],
  templateUrl: './uzemszunet-sav.component.html',
  styleUrls: ['./uzemszunet-sav.component.scss'],
})
export class UzemszunetSavComponent implements OnInit, OnChanges {
  @Input() forras = '';

  /** A megjelenítendő figyelmeztetés, vagy null (ekkor nem renderelünk semmit). */
  adat: UzemszunetForras | null = null;

  constructor(private uf: UzemszunetService) {}

  ngOnInit() { this.tolt(); }
  ngOnChanges() { this.tolt(); }

  get kieses(): boolean { return this.adat?.allapot === 'kieses'; }
  /** Közelgő (még nem kezdődött el): előzetes, előre jelzett karbantartás. */
  get elozetes(): boolean { return kozelgo(this.adat); }
  get idoablak(): string { return this.adat ? idoablakSzoveg(this.adat.idoablak_kezd, this.adat.idoablak_veg) : ''; }

  private async tolt(): Promise<void> {
    if (!this.forras) { this.adat = null; return; }
    const f = await this.uf.forras(this.forras);
    this.adat = (f && f.allapot !== 'ok' && aktivVagyJovobeli(f)) ? f : null;
  }
}
